import React from 'react'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import InstagramIcon from '@material-ui/icons/Instagram'
import WebsiteIcon from '@material-ui/icons/Public';

function ProfileAuthorDataCard() {
    return (
        <div className="aboutTheAuthor">
            <p className="descriptions">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam hic veritatis, porro dolorem provident quibusdam, deserunt ratione, quae cupiditate illo commodi itaque. Illo quas laborum aliquam nemo nostrum odio necessitatibus a excepturi veniam id nisi labore debitis earum, ipsa rerum perspiciatis libero eum dolorum unde, alias magnam! Sint, ipsum.</p>
            <ul className="authorExternalLink profileAuthorActionCard">
                <li><a href="#"><FacebookIcon /></a></li>
                <li><a href="#"><TwitterIcon /></a></li>
                <li><a href="#"><LinkedInIcon /></a></li>
                <li><a href="#"><InstagramIcon /></a></li>
                <li><a href="#"><WebsiteIcon /></a></li>
            </ul>
        </div>
    )
}

export default ProfileAuthorDataCard
